import styled from 'styled-components';

export const Container = styled.div`
  align-self: center;
  border-radius: 30px;
  margin-bottom: 4px;
  object-fit: cover;

  label {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }

    img {
      width: 298px;
      height: 90px;
      border-radius: 30px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      background: #eee;
      object-fit: cover;
    }

    input {
      display: none;
    }
  }
`;

export const DefaultAvatar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  width: 298px;
  height: 90px;
  border: 1px dashed #cdcdcd;
  background: #fff;
  border-radius: 30px;

  span {
    color: #ddd;
    font-size: 16px;
    font-weight: bold;
  }
`;
